<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10"><span class="th10">Dedication</span></h1>
<p class="p1"><span class="t1">I would wholeheartedly like to thank Paul Richmond, Associate Art Director of Dreamspinner Press, for answering my questions about art in the publishing world during the writing of this story. Thank you kindly for all your help, Paul.</span></p>
<p class="p1"><span class="t1"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?a2605a08